import i18n from '@/i18n';

/**
 * Formats an error object for checkout/order flow.
 * Extracts err_message and err_title from backend response.
 *
 * @param {Object} error - The error object with response.data.err_message and response.data.err_title
 * @returns {Object} - { message: string, title?: string }
 */
export function formatOrderError(error) {
    if (!error?.response?.data?.err_message) {
        return { message: i18n.t('cannot_proceed_with_order') }
    }

    const errorMessage = error.response.data.err_message
    const errorTitle = error.response.data.err_title

    return {
        message: errorMessage,
        title: errorTitle || undefined  // Only include title if backend provides it
    }
}

export default function errMessage(error, default_message = i18n.t('unknown_error')) {
    return typeof error == 'string'
        ? error
        : (error && error.response && error.response.data)
            ? (error.response.data.err_message || error.response.data.message || error.response.data.error?.message || default_message)
            : ((error && error.message) ? error.message : default_message)
}
